import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
// 기타 react
import { connect } from "react-redux";
import compose from "recompose/compose";

// custom
import { 
    crudGetOne as crudGetOneAction,
} from "store/actions/dataActions";

import Neo4jD3 from 'components/graph/Neo4jD3'

import {
    ICONS,
    IMAGES,
    CLASS_COLORS,
    //RELATIONSHIP_TEXT,
    HIGHLIGHT
} from 'components/graph/Neo4jConstants'
import { 
    initIconMap,
    initImageMap
} from "components/graph/util/neo4jd3";

//import localNeo4jData from 'views/document/detail/neo4jData.json'

class DocumentGraphVisualizationDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            queryType: undefined,
            searchNode: undefined,
            options: {
                highlight: [],
                // Neo4j 라벨에 맞는 Font Awesome 아이콘을 사용하기 위한 이름 매칭
                icons: ICONS,
                iconMap: initIconMap(),
                images: IMAGES,
                imageMap: initImageMap(),
                classes2colors: CLASS_COLORS,
                //relationshipText: RELATIONSHIP_TEXT,
                minCollision: 60,
                //neo4jDataUrl: 'neo4jData.json',
                //neo4jData: localNeo4jData,
                nodeRadius: 25,
                onNodeDoubleClick: (node) => {
                    this.handleGetSearchNode(node);
                },
                onRelationshipDoubleClick: function(relationship) {
                    console.log('double click on relationship: ' + JSON.stringify(relationship));
                },
                zoomFit: false
            }
        };

    }

    UNSAFE_componentWillReceiveProps(nextProps) { // componentWillReceiveProps has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.
        // refresh의 경우 데이타 새로 가져옴
        console.log("UNSAFE_componentWillReceiveProps");
        if (
            (nextProps.selectedSearchConditions.length > 0 && nextProps.params !== this.props.params) ||
            nextProps.refreshVersion !== this.props.refreshVersion
        ) {
            this._getItems(nextProps);
        }
      }



    // 리렌더링이 불필요한 케이스 정의
    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.isLoading === this.props.isLoading &&
            nextState.queryType === this.state.queryType &&
            nextProps.item === this.props.item
        ) {
            console.log("DocumentGraphVisualizationDetail >> shouldComponentUpdate : false");
            return false;
        }
        console.log("DocumentGraphVisualizationDetail >> shouldComponentUpdate : true");
        return true;
    }

    // items(목록 정보) 가져오기
    _getItems(nextProps) { // 이 부분 수정하기
        // Layout에서 params가 세팅된 뒤에 목록정보 가져옴
        console.log("DocumentGraphVisualizationDetail >> _getItems")
        if (nextProps.params.pageSize) {
            this.props.dispatchCrudGetOne(`${this.props.menu}.init`, {
                ...nextProps.params
            });

            
            let highlight = nextProps.selectedSearchConditions.filter(condition => nextProps.params[condition] && nextProps.params[condition].length > 0)
            .map( condition => (
                {
                    ...HIGHLIGHT[condition],
                    value: nextProps.params[condition] && nextProps.params[condition].length > 0 && nextProps.params[condition]
                }
            ));

            this.setState({
                queryType: 'init',
                options: {
                    ...this.state.options,
                    highlight: highlight
                }
            });
        }
    }

    handleGetSearchNode = (node) => { // labels 값이 두개일때 어떻게 할지 고민
        
        this.setState({
            queryType: 'add',
            searchNode: node
        });

        const newParams = { 
            searchType: node.labels,
            searchCond: node.id
        };
        this.props.dispatchCrudGetOne(
            `${this.props.menu}.add`, 
            newParams, 
            {isPopup: true, isLoading: false}
        );
    }

    render() {
        const { 
            item,
            isLoading
        } = this.props;
        const {
            queryType,
            searchNode,
            options
        } = this.state;

        return (
            <Fragment>
            {
                (queryType === "init" && isLoading) ? 
                null :  
                <Neo4jD3 _selector="neo4jd3" _options={options} _data={item} _queryType={queryType} _searchNode={searchNode} />
            }
            </Fragment>
            
        );
    }
}

export default compose(
    connect(
        ( state, props ) => ({
            isLoading: state.main.loadingVersion > 0,
            refreshVersion: state.main.refreshVersion,
            selectedSearchConditions: state.main.selectedSearchConditions,
            params: state.main.params,
            item: state.main.rest && state.main.rest.graph,
        }), {
            dispatchCrudGetOne: crudGetOneAction,
        }
    ),
    
)(DocumentGraphVisualizationDetail);
